import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Marker } from 'components';
import { abbreviateNumber } from 'shared/helpers/abbreviateNumber';
import s from './styles.module.scss';

interface TapButtonProps {
  onClick?: () => void;
  isDisabled?: boolean;
  coins: number;
}

export const ClemButton: FC<TapButtonProps> = ({ onClick, isDisabled, coins }) => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <div className={s.buttonWrapper}>
        <button className={s.button} disabled={isDisabled} onClick={onClick}>
          <Marker classNames={s.marker} />
          <div className={s.coin}>
            <div className={s.buttonRing}>
              <div className={s.tapButton}>
                <div className={s.text}>{t('common.takeIncome')}</div>
                <div className={s.coins}>
                  <div className={s.icon}>
                    <Icon iconName={'coin'} />
                  </div>
                  <div>{abbreviateNumber(coins)}</div>
                </div>
              </div>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};
